import * as sagas from 'exacta-material-react/lib/src/store/sagas';

import executor from './executor.saga';
import resources from './resources.saga';
import tctSagas from './tct.saga';

export default {
  ...sagas,
  executor,
  resources,
  tctSagas,
};
